// import { Form } from 'react-bootstrap';
// import React, { useState, useEffect, useRef } from 'react';
 
// const NumericControl = (props = {}) => {
//     let state = {
//         placeholder:"",
//         disable:false,
//         id:"",
//         className:"",
//         hidePlaceholder:false,
//         styles:{width:"160px",marginLeft:"10px"},
//         initialValue:"0",
//         maxValue:props.options.maxValue,
//         minValue:props.options.minValue

//     };
//     if(typeof props.options !== "undefined"){
//          state = {...state, ...props.options};
//     }
//     const handleOnChange = (e) => {
//         

//         const newValue = e.target.value;
        
//         if(typeof props.SelectionChangeCallback === "function"){
//              props.SelectionChangeCallback(e.target.value);
//              setValue(newValue);
//         }
//     }

//     //Extra
//     const [value, setValue] = useState(props.options.initialValue || "24"); 
//     useEffect(() => {
//         setValue(parseInt(props.options.initialValue));
//     }, [props.options.initialValue]);

//     useEffect(() => {
//         setValue(parseInt(props.options.initialValue));
//     }, [props.SetValueInControl])

//     useEffect(() => {

//     }, [value])
//     //Extra


//     return(
//         <Form.Group><Form.Control style={state.styles} className={state.className} name={state.className} type="number" max={state.maxValue} min={state.minValue} defaultValue={value}  onChange={handleOnChange}/> </Form.Group>
//     )
// }
 
// export default NumericControl;
import { Form } from 'react-bootstrap';
import React, { useState, useEffect, useRef } from 'react';

const NumericControl = ({ value, onChange }) => {
    const handleOnChange = (e) => {
        try {
            
            let newValue = Number(e.target.value);

            // Ensure the value stays within the range 0-24
            if (newValue < 0) newValue = 0;
            if (newValue > 24) newValue = 24;
    
            onChange(newValue);
    
        } catch (error) {
            
        }
    }

    return (
        <input
            id="RequestTotalHoursOptions"
            className="RequestTotalHoursOptions form-control"
            style={{width:"64px",marginLeft:"10px", maxWidth:"70px", position:"relative", outline:0, backgroundColor:"var(--rmsc-bg)"}}
            type="number"
            value={value}
            min={0}
            max={24}
            onChange={(handleOnChange)}
        />
    );
};

export default NumericControl;